import React from 'react';
import clsx from 'clsx';

const CrudTab: React.FC<{ className?: string }> = ({ className, children }) => {
  return <div className={clsx(className, 'layout_CrudTab')}>{children}</div>;
};

export default CrudTab;
